import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import WebsitePermissionFormContainer from "./WebsitePermissionFormContainer";
import type { CountryAccessDisplayContainerProps } from "./CountryAccessDisplayContainer";

/** A NetCapital site of the country, as the permission blocks read it. */
type CountrySite = {
  _id: string;
  canonial_url?: string;
  country_code?: string;
  domain?: string;
};

export type CountryAccessDisplayViewProps = {
  name: string;
  sites?: CountrySite[];
  error?: unknown;
  oldPermissionUpdateForm?: CountryAccessDisplayContainerProps["oldPermissionUpdateForm"];
};

const CountryAccessDisplayView = ({
  name,
  sites,
  error,
  oldPermissionUpdateForm,
}: CountryAccessDisplayViewProps) => {
  let content: React.ReactNode;

  if (error) {
    content = <h4 className="display-3 mb-0">Error loading sites.</h4>;
  } else if (!sites || sites.length === 0) {
    content = <h4 className="display-3 mb-0">No NetCapital sites associated to this country.</h4>;
  } else {
    content = sites.map((site) => (
      <WebsitePermissionFormContainer
        key={site._id}
        siteName={site.canonial_url}
        CountryCode={site.country_code}
        siteId={site._id}
        siteDomain={site.domain}
        
        oldPermissionUpdateForm={
          Array.isArray(oldPermissionUpdateForm)
            ? oldPermissionUpdateForm.find((p) => p.siteId === site._id)
            : undefined
        }
      />
    ));
  }

  return (
    <Row>
      <Col>
        <Card className="bg-gradient-white">
          <CardBody>
            <CardTitle tag="h3">{name}</CardTitle>
            <Row className="row-example">{content}</Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default CountryAccessDisplayView;
